import { apiCall } from '@api/resources/apiCall'
import { Message } from '@smwb/summer-ui'
import { getErrorMessage } from '@api/utils/errorHandler'
import { generatePath, Link } from 'react-router-dom'
import style from './missions.module.less'
import { Urls } from '@/urls'
import { useEffect } from 'react'
import { Loader } from '@modules/common/loader'

export function Missions() {
  const { data = [], isLoading, error } = apiCall.useMissionsControllerFindQuery([])

  useEffect(() => {
    document.title = 'Агентум'
  }, [])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div>
      <div className={style.layout}>
        {data.map((el) => {
          return (
            <div key={el._id} className={style.missionBlock}>
              {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
              <Link to={generatePath(Urls.Mission, { missionId: el._id! })}>
                <div className={`${style.missionBlock} ${style.icon}`}>
                  {el.icon && (
                    <img
                      src={`data:image/svg+xml;utf8,${encodeURIComponent(el.icon)}`}
                      width={40}
                      height={40}
                    />
                  )}
                </div>
              </Link>
              <div>{el.mission_name}</div>
            </div>
          )
        })}
        {!!error && (
          <Message variant={'filled'} type='error'>
            {getErrorMessage(error)}
          </Message>
        )}
      </div>
    </div>
  )
}
